module.exports = __webpack_public_path__ + "img/vegetable-shallots-190x100.8f2cc756.jpg";